import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { motion } from "framer-motion"; // ✅ For smooth page transitions
import ScrollToTop from "./components/ScrollToTop"; // ✅ Ensures pages start at top
import "./App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// ✅ Importing Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Features from "./pages/Features";
import Blog from "./pages/Blog";
import Blog1 from "./pages/Blog1";
import Blog2 from "./pages/Blog2";
import Blog3 from "./pages/Blog3";
import Blog4 from "./pages/Blog4";
import Blog5 from "./pages/Blog5";
import Blog6 from "./pages/Blog6";
import Assessment from "./pages/Assessment"; // ✅ New Risk Assessment Page

// ✅ Page Transition Animations
const pageVariants = {
  initial: { opacity: 0, y: 20 },
  in: { opacity: 1, y: 0 },
  out: { opacity: 0, y: -20 },
};

function App() {
  return (
    <Router>
      <ScrollToTop /> {/* ✅ Forces all pages to start at the top */}
      <Navbar />
      <Routes>
        {/* ✅ Home Page */}
        <Route path="/" element={
          <motion.div initial="initial" animate="in" exit="out" variants={pageVariants}>
            <Home />
          </motion.div>
        } />

        {/* ✅ Other Pages */}
        <Route path="/about" element={<motion.div initial="initial" animate="in" exit="out" variants={pageVariants}><About /></motion.div>} />
        <Route path="/features" element={<motion.div initial="initial" animate="in" exit="out" variants={pageVariants}><Features /></motion.div>} />
        <Route path="/blog" element={<motion.div initial="initial" animate="in" exit="out" variants={pageVariants}><Blog /></motion.div>} />

        {/* ✅ Blog Pages */}
        <Route path="/blog1" element={<motion.div initial="initial" animate="in" exit="out" variants={pageVariants}><Blog1 /></motion.div>} />
        <Route path="/blog2" element={<motion.div initial="initial" animate="in" exit="out" variants={pageVariants}><Blog2 /></motion.div>} />
        <Route path="/blog3" element={<motion.div initial="initial" animate="in" exit="out" variants={pageVariants}><Blog3 /></motion.div>} />
        <Route path="/blog4" element={<motion.div initial="initial" animate="in" exit="out" variants={pageVariants}><Blog4 /></motion.div>} />
        <Route path="/blog5" element={<motion.div initial="initial" animate="in" exit="out" variants={pageVariants}><Blog5 /></motion.div>} />
        <Route path="/blog6" element={<motion.div initial="initial" animate="in" exit="out" variants={pageVariants}><Blog6 /></motion.div>} />

        {/* ✅ New Risk Assessment Page */}
        <Route path="/assessment" element={<motion.div initial="initial" animate="in" exit="out" variants={pageVariants}><Assessment /></motion.div>} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;